import Mutations from '../../odata/mutations';

export default { ...new Mutations('medicalDeviceRiskClass'), ...new Mutations('medicalDeviceRiskClasses') };
